import { orderBy, findIndex, get } from 'lodash';
import * as Func from "../helpers/functions";
import BaseModel from './BaseModel';
export default class Page extends BaseModel {
    constructor(data = {}) {
        super(data);
        this.setData(data)
    }

    setData(data = this.__data__) {
        this.id = data.id;
        this.title = data.title || this.translate.title || undefined;
        this.order = data.order;
        this.description = data.description || this.translate.description || undefined;
        this.content = data.content || this.translate.content || undefined;
        this.createdDate = data.createdDate || undefined;
        this.isAvailable = data.isAvailable !== undefined ? data.isAvailable : true;
        this.setShowImage(data);
        this.setShowImageHeader(data);
        this.categories = data.categories || [];
        this.setShowCategories(data);
        this.source = data.source;
    }

    setShowImage(data) {
        if (data.thumbImageView || this.translate.thumbImageView) {
            this.thumbImage = this.translate.thumbImageView ? {
                url: this.translate.thumbImageView.fileUri,
                name: this.translate.thumbImageView.filename
            } : {
                url: data.thumbImageView.fileUri,
                name: data.thumbImageView.filename
            }
        }
    }

    setShowImageHeader(data) {
        if (data.headerImageView || this.translate.headerImageView) {
            this.headerImage = this.translate.headerImageView ? {
                url: this.translate.headerImageView.fileUri,
                name: this.translate.headerImageView.filename
            } : {
                url: data.headerImageView.fileUri,
                name: data.headerImageView.filename
            }
        }
    }

    setShowCategories(data) {
        if (data.categories) {
            let arrayCategories = [];
            data.categories.map((i) => {
                arrayCategories.push(i.id);
            });
            this.categoryIds = arrayCategories;
        } else {
            this.categoryIds = []
        }
    }

    setImage(url, name) {
        this.thumbImage = url && { url, name }
    }

    setImageHeader(url, name) {
        this.headerImage = url && { url, name }
    }

    removeImage(url) {
        this.thumbImage = undefined;
    }

    removeImageHeader(url) {
        this.headerImage = undefined;
    }

    export(hasTranslate = false) {
        const result = super.export({
            id: this.id,
            title: this.title,
            order: this.order,
            description: this.description,
            content: this.content,
            isAvailable: this.isAvailable,
            thumbImage: this.thumbImage.name,
            headerImage: this.headerImage && this.headerImage.name,
            categoryIds: this.categoryIds,
            source: this.source,
        });
        if (hasTranslate) result.translate = () => {
            return {
                id: this.translate.id,
                postId: this.translate.postId || this.id,
                title: this.title,
                description: this.description,
                content: this.content,
                thumbImage: this.thumbImage.name,
                headerImage: this.headerImage && this.headerImage.name,
                languageCode: this.languageCode,
            }
        }
        return result;
    }

}
